import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/copyDoc.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleCopyEvent } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleCopyEvent
}

const ArticleCopy = ({ event, ...props }: Props) => {
  const {
    user,
    article,
    data: { source_article, status_name, status_color },
  } = event

  const isSourceArticle = source_article.key === article.key

  const content = isSourceArticle ? (
    <>
      <Actor displayName={user?.display_name || 'Anonymous user'} userId={user?.id} /> copied this document
    </>
  ) : (
    <>
      <Actor displayName={user?.display_name || 'Anonymous user'} userId={user?.id} /> copied this document from:{' '}
      <Link to={source_article.url} onClick={stopPropagation}>
        {source_article.title}
      </Link>
    </>
  )

  return (
    <BaseActivityEvent
      {...props}
      status={!isSourceArticle && status_name && status_color ? { name: status_name, color: status_color } : undefined}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={content}
    />
  )
}

export { ArticleCopy }
